import useSite from "@casino/legacy/client/hooks/useSite";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import { cn } from "@workspace/frontend-ui";
import HeaderWrapper from "./HeaderWrapper";

type Props = {
  id: string;
};

const AuthBrandHeading: FC<Props> = ({ id }) => {
  const { isBitcasino } = useSite();

  return (
    <HeaderWrapper>
      <h1
        className={cn(
          "text-2xl font-semibold text-foreground",
          isBitcasino && "font-headline font-normal",
        )}
      >
        <Translate id={id} />
      </h1>
    </HeaderWrapper>
  );
};

export default AuthBrandHeading;
